import React, { useEffect, useRef, useState } from 'react';
import { List, Telephone, X } from 'react-bootstrap-icons';
import logo from './images/logo.jpg';
import './NavBar.css';

const links = [
  { href: '#top', label: 'ראשי' },
  { href: '#services', label: 'שירותים' },
  { href: '#projects', label: 'פרויקטים' },
  { href: '#about', label: 'אודות' },
  { href: '#contact', label: 'צור קשר' }
];

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (isOpen && navRef.current && !navRef.current.contains(event.target)) setIsOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };

    document.addEventListener('pointerdown', closeOnOutsideClick);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOnOutsideClick);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [isOpen]);

  return (
    <header className="site-header" ref={navRef}>
      <nav className="navigation content-width" aria-label="ניווט ראשי">
        <a className="brand" href="#top" aria-label="אליגמן פתרונות הנדסיים — ראשי">
          <img src={logo} alt="לוגו אליגמן פתרונות הנדסיים" />
          <span><strong>אליגמן פתרונות הנדסיים</strong><small>Eligman Engineering Solutions LTD</small></span>
        </a>

        <button
          className="menu-toggle"
          type="button"
          aria-expanded={isOpen}
          aria-controls="main-menu"
          aria-label={isOpen ? 'סגירת תפריט' : 'פתיחת תפריט'}
          onClick={() => setIsOpen((value) => !value)}
        >
          {isOpen ? <X aria-hidden="true" /> : <List aria-hidden="true" />}
        </button>

        <div id="main-menu" className={`main-menu ${isOpen ? 'is-open' : ''}`}>
          <div className="nav-links">
            {links.map((link) => (
              <a key={link.href} href={link.href} onClick={() => setIsOpen(false)}>{link.label}</a>
            ))}
          </div>
          <a className="nav-cta" href="tel:0545995998" onClick={() => setIsOpen(false)}>
            <Telephone aria-hidden="true" />חייגו עכשיו
          </a>
        </div>
      </nav>
    </header>
  );
}

export default NavBar;
